import { css } from '@microsoft/fast-element';
import { genericFormStyling } from '../../../../../styles';

export const MarketInfoTabStyles = css`
  ${genericFormStyling}
  zero-text-area,
  zero-text-field,
  zero-select {
    width: 100%;
  }

  .form-control zero-text-field {
    padding-bottom: 0;
  }
`;
